import { Analytics } from '../../helpers/analyticsMiddleware';
import { t } from '../../strings/i18n/i18n';
import { triggerAnalyticsEvent } from 'syf-js-utilities';
export var getPrimaryButtonText = function (isCancelSubmitted) {
    return isCancelSubmitted
        ? "".concat(t('button.close'))
        : "".concat(t('button.cancelDispute'));
};
export var getPrimaryButtonReason = function (isCancelSubmitted) {
    return isCancelSubmitted ? 'Close' : 'Cancel dispute';
};
export var getHelpText = function (charactersRemaining) {
    return charactersRemaining === 1
        ? t('questionnaire.oneCharacterCountHelpText')
        : t('questionnaire.characterCountHelpText', { charactersRemaining: charactersRemaining });
};
export var getCancelStatusType = function (isCanceled) {
    if (isCanceled) {
        return 'confirmation';
    }
    return 'error';
};
export var checkForAnalyticsEvent = function (formError) {
    if (formError) {
        triggerAnalyticsEvent({
            PageKind: Analytics.Dispute,
            PageFunction: Analytics.Billing,
            PageSubFunction: Analytics.Documents,
            pageName: Analytics.ConfirmCancelError
        });
    }
};
export var setSecondaryButtonHandler = function (isCancelSubmitted, fireCloseModal) {
    return !isCancelSubmitted ? fireCloseModal : null;
};
export var getAnalyticsPageName = function (isCancelSubmitted, cancelDisputeError) {
    if (cancelDisputeError) {
        return Analytics.Sorry;
    }
    if (isCancelSubmitted) {
        return Analytics.CancelInProgress;
    }
    return Analytics.CancelConfirmation;
};
//# sourceMappingURL=helpers.js.map